var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBarcodeMismatchIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "74px",
    height: "25px",
    viewBox: "0 0 74 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Mismatch") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HSP-view",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Nurse-view---vertical-panel",
    transform: "translate(-338.000000, -521.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "live-cards",
    transform: "translate(313.000000, 145.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "card1",
    transform: "translate(8.000000, 50.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mismatch",
    transform: "translate(12.000000, 327.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(33.000000, 8.000000)",
    stroke: "#EB3C39",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5,0.5 L0.5,10.5",
    id: "Line-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5,3.5 L12.5,3.5",
    id: "Line-10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5,7.5 L12.5,7.5",
    id: "Line-10-Copy"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icon/person/person_black"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(5.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5,15.5463191 C12.9231608,15.5463191 14.4840234,15.7492054 16.1826347,16.1549841 C18.1107881,16.6283926 19.6716507,17.2595945 20.8652695,18.0486087 C22.2884303,18.9728824 23,20.0098569 23,21.1595632 L23,24 L0,24 L0,21.1595632 C0,20.0098569 0.711569731,18.9728824 2.13473054,18.0486087 C3.32834928,17.2595945 4.88921192,16.6283926 6.81736527,16.1549841 C8.51597656,15.7492054 10.0768392,15.5463191 11.5,15.5463191 Z M11.5,12.7058824 C10.4670607,12.7058824 9.51447542,12.4522745 8.64221557,11.9450511 C7.76995572,11.4378277 7.07560138,10.7559042 6.55913174,9.8992603 C6.04266209,9.04261636 5.78443114,8.10708503 5.78443114,7.09263825 C5.78443114,6.07819148 6.04266209,5.13138869 6.55913174,4.25220148 C7.07560138,3.37301427 7.76995572,2.67981937 8.64221557,2.17259598 C9.51447542,1.6653726 10.4670607,1.41176471 11.5,1.41176471 C12.5329393,1.41176471 13.4855246,1.6653726 14.3577844,2.17259598 C15.2300443,2.67981937 15.9243986,3.37301427 16.4408683,4.25220148 C16.9573379,5.13138869 17.2155689,6.07819148 17.2155689,7.09263825 C17.2155689,8.10708503 16.9573379,9.04261636 16.4408683,9.8992603 C15.9243986,10.7559042 15.2300443,11.4378277 14.3577844,11.9450511 C13.4855246,12.4522745 12.5329393,12.7058824 11.5,12.7058824 Z",
    id: "icon/person/black",
    fill: "#EB3C39",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(2.927622, 0.000000)",
    stroke: "#EB3C39",
    strokeWidth: 0.705882353
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path-12-Copy-4",
    transform: "translate(3.567439, 2.115705) rotate(-360.000000) translate(-3.567439, -2.115705) ",
    points: "5.69737803 -6.44713466e-11 1.4375 -6.59274909e-11 1.4375 4.23141059"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-12-Copy-5",
    transform: "translate(3.567439, 11.998058) rotate(-90.000000) translate(-3.567439, -11.998058) ",
    points: "5.65924613 9.8437854 1.4756319 9.8437854 1.4756319 14.1523311"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-12-Copy-6",
    transform: "translate(13.629939, 11.998058) rotate(-180.000000) translate(-13.629939, -11.998058) ",
    points: "15.759878 9.88235294 11.5 9.88235294 11.5 14.1137635"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-12-Copy-7",
    transform: "translate(13.629939, 2.115705) rotate(-270.000000) translate(-13.629939, -2.115705) ",
    points: "15.7217461 -0.0385675444 11.5381319 -0.0385675444 11.5381319 4.26997814"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "barcode",
    transform: "translate(52.000000, 0.000000)",
    fill: "#EB3C39"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 2.62012634e-13,
    width: 1.91911765,
    height: 23.394958
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    x: 3.83823529,
    y: 2.62012634e-13,
    width: 3.83823529,
    height: 23.394958
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    x: 9.59558824,
    y: 2.62012634e-13,
    width: 1.91911765,
    height: 23.394958
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    x: 15.3529412,
    y: 2.62012634e-13,
    width: 1.91911765,
    height: 23.394958
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-9",
    x: 21.1102941,
    y: 2.62012634e-13,
    width: 1.91911765,
    height: 23.394958
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-10",
    x: 24.9485294,
    y: 2.62012634e-13,
    width: 1.91911765,
    height: 23.394958
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarcodeMismatchIcon);
export default __webpack_public_path__ + "static/media/barcode_mismatch_icon.38d79247d6ba291182f7ab840d0fd37c.svg";
export { ForwardRef as ReactComponent };